import { render, staticRenderFns } from "./RequireNewPassword.vue?vue&type=template&id=52555c64&scoped=true&"
import script from "./RequireNewPassword.vue?vue&type=script&lang=ts&"
export * from "./RequireNewPassword.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52555c64",
  null
  
)

export default component.exports